import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { BranchLovComponent } from 'src/app/assabil-admin/components/control-tables/branch/branch-lov/branch-lov.component';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { TicketBatch } from '../../models/entities/ticket-batch';
import { TicketService } from '../../services/ticket-service';
import { Field } from 'src/app/tools/models/dtos/field';
import { RoleLovComponent } from 'src/app/assabil-admin/components/master-data/role/role-lov/role-lov.component';
import { PersonLovComponent } from 'src/app/assabil-admin/components/master-data/person/person-lov/person-lov.component';
import { TicketPipe } from '../../pipes/ticket-pipe';
import { TicketBatchTicketPipe } from '../../pipes/ticket-batch-ticket-pipe';


@Component({
    selector: 'ticket-batch-list',
    templateUrl: './ticket-batch-list.component.html',
    styleUrls: ['./ticket-batch-list.component.scss']
})


export class TicketServiceListComponent extends BasePage2<TicketBatch> {

    ticketBatchCode   : string;
    branch            : Branch;
    startDate         : Date;
    endDate           : Date;

    branchLovComponent = BranchLovComponent;
    
    ticketBatchs    : TicketBatch[] = [];

    ticketBatchTicketsColumns   : any[];


    constructor(
    protected ticketService         : TicketService,
    protected toastr                : ToastrService,
    protected router                : Router,
    protected baseService           : BaseService,
    public    leanUtilsService      : LeanUtilsService, 
    protected location              : Location,
    protected activatedRoute        : ActivatedRoute) {
      super(toastr, router, baseService, leanUtilsService, location);
      this.entityName = 'ticketBatch';
    }


ticketBatchTicketPipe             : TicketBatchTicketPipe = new TicketBatchTicketPipe();
//--------------------------------------------------------------------------------------------------------
ngOnInit() {
  super.ngOnInit();
    this.baseService.fieldsGet("ticketBatchTicket").then(result => {
      this.ticketBatchTicketsColumns = result.listFields;

      this.ticketBatchTicketsColumns.forEach(field => { 
        if (field.prop == 'ticket.progressLevel') {
          field.pipe = this.ticketBatchTicketPipe;
        }
      })
    });
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
  getRows(): TicketBatch[] {
      return this.ticketBatchs;
  }
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
newTicketBatch(){
  let ticketBatch : TicketBatch = new TicketBatch();
  ticketBatch.inserted = true;
  ticketBatch.edit     = true;
  ticketBatch.theDate  = new Date();
  this.selectedRow     = ticketBatch;
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
loadData() {
 
  let branchCode        : string = null;
  let progressLevel     : number = null;


  if (this.branch) branchCode = this.branch.branchCode;

  this.ticketService.ticketBatchsGet(
    this.ticketBatchCode,
    branchCode      ,
    progressLevel   ,
    this.startDate  ,
    this.endDate         ).then(result => {
      this.ticketBatchs = result;
  });
}
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
selectRow(ticketBatch : TicketBatch){
  this.ticketService.ticketBatchGet(ticketBatch.id).then(ticketBatch => {
      this.selectedRow = ticketBatch;
  });
}
//--------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------
enrichField(field : Field){  

  if (field.prop == 'role')               { field.modal = RoleLovComponent;    field.subProp = 'name';}
  if (field.prop == 'person')             { field.modal = PersonLovComponent;  field.subProp = 'name';}

  if (field.prop == 'assignedToRole')     { field.modal = RoleLovComponent;    field.subProp = 'name';}
  if (field.prop == 'executedByPerson')   { field.modal = PersonLovComponent;  field.subProp = 'name';}
  if (field.prop == 'closedByRole')       { field.modal = RoleLovComponent;    field.subProp = 'name';}
  if (field.prop == 'closedByPerson')     { field.modal = PersonLovComponent;  field.subProp = 'name';}

}
//--------------------------------------------------------------------------------------------------------

}
